module.exports = __webpack_public_path__ + "img/pv-remove.09b32f99.svg";